import { Phone, MessageCircle } from "lucide-react";
import { useSiteSettings } from "@/contexts/SiteSettingsContext";

export default function StickyButtons() {
  const { settings } = useSiteSettings();
  const c = settings.contact;
  const phone = c.phone;
  const whatsapp = c.whatsappNumber.replace(/[^0-9]/g, "") || phone.replace(/[^0-9]/g, "");

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3">
      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/${whatsapp}?text=${encodeURIComponent("Hi, I'm interested in properties")}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 active:scale-95 transition-all"
      >
        <MessageCircle className="w-7 h-7 text-white" />
      </a>

      {/* Call Button */}
      <a
        href={`tel:${phone.replace(/\s/g, "")}`}
        aria-label="Call us"
        className="w-14 h-14 rounded-full bg-accent flex items-center justify-center shadow-lg hover:shadow-gold hover:scale-110 active:scale-95 transition-all"
      >
        <Phone className="w-6 h-6 text-accent-foreground" />
      </a>
    </div>
  );
}
